import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Card, Typography, Avatar } from '@mui/material';

import { Label } from 'components';
import gradients from 'utils/gradients';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	details: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	label: {
		marginLeft: theme.spacing(1),
	},
	avatar: {
		backgroundImage: gradients.blue,
		height: 48,
		width: 48,
	},
}));

const TodaysMoney = (props) => {
	const { className, title, text, icon, label, ...rest } = props;

	const classes = useStyles();

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<div>
				<Typography component="h3" gutterBottom variant="overline">
					{title}
				</Typography>
				<div className={classes.details}>
					<Typography variant="h3">
						{text}
					</Typography>
					{label && (
						<Label
							className={classes.label}
							color={label.color}
							variant="outlined"
						>
							{label.text}
						</Label>
					)}

				</div>
			</div>
			<Avatar className={classes.avatar}>
				{icon}
			</Avatar>
		</Card>
	);
};

TodaysMoney.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	text: PropTypes.any,
	icon: PropTypes.object,
	label: PropTypes.object
};

export default TodaysMoney;
